import * as THREE from 'three';

export type GroundPlaneProps = {
  size?: number;
  opacity?: number;
  color?: string;
};

export default function GroundPlane({
  size = 40,
  opacity = 0.5,
  color = '#888888',
}: GroundPlaneProps) {
  return (
    <mesh
      rotation={[-Math.PI / 2, 0, 0]}
      position={[0, 0, 0]}
      receiveShadow
      renderOrder={-1}
      name="GroundPlane"
    >
      <planeGeometry args={[size, size]} />
      <meshStandardMaterial
        color={color}
        transparent={true}
        opacity={opacity}
        side={THREE.DoubleSide}
        depthWrite={false}
      />
    </mesh>
  );
}
